<div class="row">
  <div class="col-12">
    
    <div class="serverErrorMessage" *ngIf="serverErrorMessageShown">
      <div class="alert alert-danger mb-4 py-4" role="alert" >
        <p>We encountered an issue completing your request.</p>
        <span>Please contact Customer Service at {{ customerServicePhone }}.</span>
      </div>
    </div>

    <form id="resetPasswordByEmailForm" [formGroup]="resetPasswordByEmailForm" (ngSubmit)="resetPasswordByEmail()">

      <div class="form-group form-label-group">
        <input id="usernameInput" formControlName="usernameInput" class="form-control"
          placeholder="Enter Username"
          [ngClass]="{ 'is-invalid': sendVerificationEmailButtonClicked && resetPasswordByEmailForm.controls.usernameInput.errors }">
          <label for="usernameInput">Username</label>
          <div *ngIf="sendVerificationEmailButtonClicked && resetPasswordByEmailForm.controls.usernameInput.errors" class="invalid-feedback">
            <div *ngIf="resetPasswordByEmailForm.controls.usernameInput.errors.required">Username is required.</div>
          </div>
      </div>

      <div class="form-group form-label-group">
        <input id="emailInput" formControlName="emailInput" class="form-control"
               placeholder="Enter Verified Email"
               [ngClass]="{ 'is-invalid': sendVerificationEmailButtonClicked && resetPasswordByEmailForm.controls.emailInput.errors }">
        <label for="emailInput">Verified Email</label>
        <div *ngIf="sendVerificationEmailButtonClicked && resetPasswordByEmailForm.controls.emailInput.errors" class="invalid-feedback">
          <div *ngIf="resetPasswordByEmailForm.controls.emailInput.errors.required">Email Address is required.</div>
          <div *ngIf="resetPasswordByEmailForm.controls.emailInput.errors.email">Email Address is invalid.</div>
        </div>
      </div>

      <div class="row" *ngIf="!verificationEmailRequestSent" [@showSendVerificationEmailButton]>
        <div class="col-12 d-flex">
          <button type="submit" form="resetPasswordByEmailForm" class="btn rounded-pill bg-secondary ml-auto text-white">
            <span class="font-weight-bold">Send Verification Email</span>
          </button>
        </div>
      </div>
    </form>

    <div *ngIf="verificationEmailRequestSent" [@showConfirmationCodeWindow]>
      <app-verify-confirmation-code-by-email [username]="getUsernameValue()" [emailAddress]="getEmailValue()">
      </app-verify-confirmation-code-by-email>
    </div>

  </div>
</div>
